import { TranslateService } from '@ngx-translate/core';

export type MeasureType = 'value' | 'text' | 'photo';

export function normalizeMeasureType(data: any): MeasureType | null {
  if (!data) {
    return null;
  }
  if (data.measure_type) {
    return data.measure_type;
  }
  return data.measure === true ? 'value' : null;
}

export function getMeasureTypeItems(
  translate: TranslateService
): { value: MeasureType; name: string }[] {
  return (['value', 'text', 'photo'] as MeasureType[]).map((value) => ({
    value,
    name: translate.instant(`headers.fastpm.pm_model.measure_${value}`)
  }));
}

/** Shared grid column for the PM task measure type. */
export function measureTypeColumn(translate: TranslateService): any {
  const label = (p: any): string =>
    p.value
      ? translate.instant(`headers.fastpm.pm_model.measure_${p.value}`)
      : '';

  return {
    headerName: translate.instant('headers.fastpm.pm_model.measure'),
    field: 'measure_type',
    filter: 'agSetColumnFilter',
    valueGetter: (params: any): MeasureType | null =>
      normalizeMeasureType(params.data),
    filterValueGetter: (params: any): MeasureType | null =>
      normalizeMeasureType(params.data),
    valueFormatter: label,
    filterParams: { valueFormatter: label },
    cellRenderer: (params: any): string =>
      params.value
        ? '<span class="badge badge-lg badge-success">' +
          label(params) +
          '</span>'
        : ''
  };
}
